/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import {
    HomeIcon,
    ChartPieIcon,
    FolderIcon,
    BoltIcon,
    BookOpenIcon,
    Cog6ToothIcon, // Replacement for SettingsInputComponentOutlinedIcon
    EnvelopeIcon, // For email validation
    CpuChipIcon, // For LLM models
    ServerIcon, // For infrastructure costs
    CreditCardIcon, // For payments
    ChatBubbleBottomCenterTextIcon // For Task Flow Assistant
} from '@heroicons/react/24/outline'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import clsx from 'clsx'
import { StarIcon } from '@heroicons/react/24/outline'
import { TableIcon } from '@radix-ui/react-icons'
import { Tooltip2 } from './pages/components/Tooltip'
import { dispatch } from 'store'
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
} from '@headlessui/react'
import Lottie from 'lottie-react';
import assistantAnimation from '../assets/assistant.json';
let adminmenus = [
    { name: 'Home', href: '/dashboard', icon: HomeIcon, current: true },
    { name: 'My tables', href: '/dashboard/tables', icon: TableIcon, current: true },
    { name: 'Task Flow Assistant', href: '/dashboard/task-flow-assistant', icon: ChatBubbleBottomCenterTextIcon, current: false },
    { name: 'Workspaces', href: '/dashboard/workspaces', icon: FolderIcon, current: true },

    {
        name: 'MCP Servers',
        icon: BoltIcon,
        current: false,
        children: [
            { name: 'MCP Servers', href: '/dashboard/mcp/servers', icon: Cog6ToothIcon, current: true },
            { name: 'Tool list', href: '/dashboard/tools' },
            { name: 'New tool', href: '/dashboard/tools/new' },
            { name: 'Email Verification', href: '/dashboard/catch-all', icon: EnvelopeIcon, current: false },
            { name: 'Category list', href: '/dashboard/category' },
            { name: 'New category', href: '/dashboard/category/new' }
        ]
    },
    {
        name: 'Analytics', href: '/dashboard/error-analytics', icon: ChartPieIcon, current: false,
        children: [

            { name: 'Queue stats', href: '/dashboard/batch/dashboard' },
            { name: 'Cost analysis', href: '/dashboard/batch/costs' },
            { name: 'Model analytics', href: '/dashboard/model-logs' },
            { name: 'Error analytics', href: '/dashboard/error-analytics' },
            { name: 'Usage', href: '/dashboard/usage' },
            { name: 'Users report', href: '/dashboard/users' },
            { name: 'Runs', href: '/dashboard/cell-runs', },
        ]
    },
    {
        name: 'System settings', href: '/dashboard/error-analytics', icon: ChartPieIcon, current: false,
        children: [

            { name: 'System settings', href: '/dashboard/connections', icon: Cog6ToothIcon, current: true },
            { name: 'System connections', href: '/dashboard/system-connections', icon: Cog6ToothIcon, current: true },
            { name: 'LLM Models', href: '/dashboard/llm', icon: CpuChipIcon, current: true },
            { name: 'Infrastructure Costs', href: '/dashboard/infrastructure-cost', icon: ServerIcon, current: true },
        ]
    },
    { name: 'Subscriptions', href: '/dashboard/subscriptions', icon: ChartPieIcon, current: false },
    { name: 'Payments', href: '/dashboard/payments', icon: CreditCardIcon, current: false },

    { name: 'Blogs', href: '/dashboard/blogs', icon: ChartPieIcon, current: false },




]
let usermenus = [
    { name: 'Home', href: '/dashboard', icon: HomeIcon, current: true },
    { name: 'My tables', href: '/dashboard/tables', icon: TableIcon, current: true },
    { name: 'Task Flow Assistant', href: '/dashboard/task-flow-assistant', icon: ChatBubbleBottomCenterTextIcon, current: false },
    { name: 'Workspaces', href: '/dashboard/workspaces', icon: FolderIcon, current: true },
    { name: 'Usage', href: '/dashboard/usage', icon: ChartPieIcon, current: false },
    { name: 'MCP Servers', href: '/dashboard/mcp/servers', icon: Cog6ToothIcon, current: true },
    { name: 'LLM Models', href: '/dashboard/llm', icon: CpuChipIcon, current: true },
]
const navigation2 = [
    {
        name: 'Upgrade',
        icon: StarIcon,
        current: false,
        href: '/dashboard/upgrade'
    }
]
const userNavigation = [
    { name: 'Your profile', href: '/dashboard/user/account' },
    { name: 'Sign out', href: '/auth/logout' },
]
let tableNavigation = [
    { name: 'Assistant', href: '#', icon:()=><div className="w-[50px] h-[50px]">
              <Lottie 
                animationData={assistantAnimation} 
                loop={false}
                autoplay={false}
              />
            </div> , current: false },
]
let assitantNavigation = [
    { name: 'Chat history', href: '#', icon: ChatBubbleBottomCenterTextIcon, current: false },
]
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
function NavItem({ item, collapsed }) {
    const location = useLocation()
    const isCurrent = (href, hasSubMenus) => location.pathname === href || (hasSubMenus && location.pathname.includes(href))

    const isCurrent2 = (href, exact = false) => {
        return exact ? location.pathname === href : (location.pathname ?? '').startsWith(href)
    }
    const onClick = (e, item) => {
        dispatch({ type: 'NAV_ITEM_CLICKED', payload: item })
    }
    const isChildVisited = (item?.children ?? []).some((subItem) => isCurrent2(subItem.href))

    // If collapsed and has children, just show the icon
    if (collapsed && item.children) {
        return (
            <li key={item.name}>
                <Tooltip2 description={item.name}>
                    <Link
                        to={item.children[0].href}
                        className={classNames(
                            isChildVisited ? 'bg-mtlite font-semibold' : '',
                            'hover:bg-gray-600/5 text-gray-700 hover:text-gray-900 group flex justify-center rounded-md p-1.5'
                        )}
                        onClick={(e) => onClick(e, item)}
                    >
                        <item.icon
                            aria-hidden='true'
                            className={classNames(
                                isChildVisited ? 'bg-mtlite font-semibold' : '',
                                'h-5 w-5 text-gray-400'
                            )}
                        />
                    </Link>
                </Tooltip2>
            </li>
        )
    }

    return (
        <li key={item.name}>
            {!item.children ? (
                collapsed ? (
                    <Tooltip2 description={item.name}>
                        <Link
                            to={item.href}
                            className={classNames(
                                isCurrent(item.href) ? 'bg-mtlite font-semibold' : '',
                                'hover:bg-gray-600/5 text-gray-700 hover:text-gray-900 group flex justify-center rounded-md p-1.5 text-sm leading-6'
                            )}
                            onClick={(e) => onClick(e, item)}
                        >
                            <item.icon
                                aria-hidden='true'
                                className={classNames(
                                    isCurrent(item.href) ? 'bg-mtlite font-semibold' : '',
                                    'h-5 w-5 shrink-0 text-gray-400'
                                )}
                            />
                        </Link>
                    </Tooltip2>
                ) : (
                    <Link
                        to={item.href}
                        onClick={(e) => onClick(e, item)}
                        className={classNames(
                            isCurrent(item.href) ? 'bg-mtlite font-semibold' : '',
                            'hover:bg-gray-600/5 text-gray-700 hover:text-gray-900 group flex gap-x-2 rounded-lg p-2 text-sm leading-6 px-6 '
                        )}
                    >
                        <item.icon
                            aria-hidden='true'
                            className={classNames(
                                isCurrent(item.href) ? 'bg-mtlite font-semibold' : '',
                                'h-6 w-6 shrink-0 text-gray-400'
                            )}
                        />
                        {item.name}
                    </Link>
                )
            ) : (
                <Disclosure as='div' key={item.name} defaultOpen={isChildVisited}>
                    {({ open }) => (
                        <>
                            <DisclosureButton
                                className={clsx(
                                    isCurrent2(item.href, true) ? 'bg-mtlite font-semibold ' : '',
                                    'group flex w-full items-center gap-x-2 rounded-md p-2 text-left hover:bg-gray-100 hover:bg-gray-600/5 text-gray-700 hover:text-gray-900 px-6'
                                )}
                            >
                                <item.icon aria-hidden='true' className='h-6 w-6 shrink-0 text-gray-400' />
                                {item.name}
                                <ChevronRightIcon
                                    className={clsx(
                                        'ml-auto h-5 w-5 shrink-0 text-gray-400 group-data-[open]:rotate-90 group-data-[open]:text-gray-500',
                                        open && 'rotate-180'
                                    )}
                                />
                            </DisclosureButton>
                            <DisclosurePanel as='ul' className='mt-1 px-2' open={open}>
                                {item.children.map((subItem, i) => (
                                    <li key={`${subItem.name}${i}`} id={subItem.name + i}>
                                        <Link
                                            to={subItem.href}
                                            className={clsx(
                                                isCurrent2(subItem.href) ? 'bg-mtlite font-semibold ' : '',
                                                'block rounded-md py-2 pl-9 pr-2 text-sm leading-6 text-gray-700 hover:bg-gray-100'
                                            )}
                                        >
                                            {subItem.name}
                                        </Link>
                                    </li>
                                ))}
                            </DisclosurePanel>
                        </>
                    )}
                </Disclosure>
            )}
        </li>
    )
}
export default function Sidebar({ collapsed = false, pathname }) {
    const { user } = useAuth()
    const location = useLocation()
    const isCurrent = (href, hasSubMenus) => location.pathname === href || (hasSubMenus && location.pathname.includes(href))
    let navigation = []
    let hideNav= false
    if (user?.role === 'admin') {
        navigation = adminmenus
    } else if (user?.role === 'user') {
        navigation = usermenus
    }
    if (pathname.includes('/dashboard/table/')) {
        navigation= tableNavigation
        hideNav=true
    } else if (pathname.includes('/dashboard/task-flow-assistant')) {
        navigation = assitantNavigation
        hideNav=true
    }
    return (
        <div
            className={classNames(
                'flex grow flex-col gap-y-5 h-[calc(100vh-60px)] overflow-hidden',
                collapsed ? 'pl-0' : ''

            )}
        >

            <nav className='flex flex-1 flex-col'>
                <ul role='list' className='flex flex-1 flex-col gap-y-7'>
                    <li>
                        <ul role='list' className='-mx-2 space-y-1 '>
                            {navigation.map((item, i) => (
                                <NavItem item={item} key={`${item.name}${i}`} collapsed={collapsed} />
                            ))}
                        </ul>
                    </li>
                    <li className='mx-2 mt-auto'>
                        <ul role='list' className='-mx-2 space-y-1'>
                            {hideNav ? null : navigation2.map((item, i) => (
                                <NavItem item={item} key={`${item.name}${i}`} collapsed={collapsed} />
                            ))}

                            <li >
                                {hideNav ? null : collapsed ? (
                                    <Tooltip2 description="Docs">
                                        <a
                                            target='_blank'
                                            href={'https://docs.meerkats.ai/quickstart'}
                                            className={classNames(
                                                isCurrent('https://docs.meerkats.ai/quickstart') ? 'bg-mtlite font-semibold' : '',
                                                'hover:bg-gray-600/5 text-gray-700 hover:text-gray-900 group flex justify-center rounded-md p-1.5 text-sm leading-6 px-6'
                                            )}
                                        >
                                            <BookOpenIcon
                                                aria-hidden='true'
                                                className={classNames(
                                                    isCurrent('https://docs.meerkats.ai/quickstart') ? 'bg-mtlite font-semibold' : '',
                                                    'h-5 w-5 shrink-0 text-gray-400'
                                                )}
                                            />
                                        </a>
                                    </Tooltip2>
                                ) : (
                                    <a
                                        target='_blank'
                                        href={'https://docs.meerkats.ai/quickstart'}
                                        className={classNames(
                                            isCurrent('https://docs.meerkats.ai/quickstart') ? 'bg-mtlite font-semibold' : '',
                                            'hover:bg-gray-600/5 text-gray-700 hover:text-gray-900 group flex gap-x-3 rounded-md p-2 text-sm leading-6 px-6'
                                        )}
                                    >
                                        <BookOpenIcon
                                            aria-hidden='true'
                                            className={classNames(
                                                isCurrent('https://docs.meerkats.ai/quickstart') ? 'bg-mtlite font-semibold' : '',
                                                'h-6 w-6 shrink-0 text-gray-400'
                                            )}
                                        />
                                        Docs
                                    </a>
                                )}
                                <Menu as="div" className="relative">
                                    <MenuButton className={
                                        collapsed ? " flex items-center " :
                                            " flex items-center p-1.5 px-6"}>
                                        {
                                            collapsed ? (
                                                <span className="inline-flex size-6 items-center justify-center rounded-full bg-mtmain ml-4">
                                                    <span className="text-sm font-medium text-white">
                                                        {user?.name?.slice(0, 1)}
                                                    </span>
                                                </span>
                                            )
                                                : <>
                                                    <span className="sr-only">Open user menu</span>
                                                    <span className="inline-flex size-6 items-center justify-center rounded-full bg-mtmain">
                                                        <span className="text-sm font-medium text-white">
                                                            {user?.name?.slice(0, 1)}
                                                        </span>
                                                    </span>
                                                    <span

                                                        className="flex items-center gap-x-4 px-2 py-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >

                                                        <span className="sr-only">Your profile</span>
                                                        <span aria-hidden="true">{user?.name?.slice(0, 20) ?? ''}</span>
                                                    </span>
                                                </>
                                        }

                                    </MenuButton>
                                    <MenuItems
                                        transition
                                        className={
                                            classNames(
                                                collapsed ? 'bottom-12 left-8' : 'bottom-16 left-12',
                                                "fixed   z-30 w-56 origin-top-left rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in")}
                                    >
                                        {userNavigation.map((item) => (
                                            <MenuItem key={item.name}>
                                                <Link
                                                    to={item.href}
                                                    className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none "
                                                >
                                                    {item.name}
                                                </Link>
                                            </MenuItem>
                                        ))}
                                    </MenuItems>
                                </Menu>
                            </li>
                        </ul>

                    </li>
                </ul>
            </nav>
        </div>
    )
}
